import { IDefineCommand } from 'core-ts-types';
import { ExternalRegistrationLinkModel, externalRegistrationLinkNk } from '../models/external_registration_link_model';

angular
  .module('capability-ng-academic-planner')
  .factory(
    'externalRegistrationLinkCommand',
    (
      $http: ng.IHttpService,
      ngExternalRegistrationLinkModel: ExternalRegistrationLinkModel,
      log: any,
      defineCommand: IDefineCommand
    ) =>
      defineCommand('externalRegistrationLinkCommand', (deferred) => {
        $http
          .get(`config/customtext/${externalRegistrationLinkNk}/`)
          .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
            ngExternalRegistrationLinkModel.clear().write(data);
            deferred.resolve();
          })
          .catch((e: ng.IHttpPromiseCallbackArg<any>) => {
            log.issue('failed to retrieve info for course');
            deferred.reject(e.data);
          });
      })
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/advisor_header/components/external_registration_link/commands/external_registration_link_command.ts